var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 1C11.745 1 1 11.745 1 25C1 38.255 11.745 49 25 49C38.255 49 49 38.255 49 25C49 11.745 38.255 1 25 1ZM19.125 34.9475H14.265V19.3075H19.125V34.9475ZM16.665 17.3875C15.13 17.3875 14.1375 16.3 14.1375 14.955C14.1375 13.5825 15.16 12.5275 16.7275 12.5275C18.295 12.5275 19.255 13.5825 19.285 14.955C19.285 16.3 18.295 17.3875 16.665 17.3875ZM36.875 34.9475H32.015V26.28C32.015 24.2625 31.31 22.8925 29.5525 22.8925C28.21 22.8925 27.4125 23.82 27.06 24.7125C26.93 25.03 26.8975 25.48 26.8975 25.9275V34.945H22.035V24.295C22.035 22.3425 21.9725 20.71 21.9075 19.305H26.13L26.3525 21.4775H26.45C27.09 20.4575 28.6575 18.9525 31.28 18.9525C34.4775 18.9525 36.875 21.095 36.875 25.7V34.9475V34.9475Z",
    fill: "#FAF4ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.7ef22a17f2dd8377d2b5884c0cbe0962.svg";
export { ForwardRef as ReactComponent };